module.exports = __webpack_public_path__ + "img/poker-d06.5d001843.svg";